export default __webpack_public_path__ + "static/media/pic5.8f07db0c.jpg";